import { IApplicantsAppointment } from "../../../model/applicant/ApplicantsAppointment";
import { DateService } from "../../../service/DateService";
import { SourceDataConstants } from "../../../common/Constants";

export interface TApplicantsAppointmentPresentationModel {
  id: number;
  positionTypeId: number;
  sourceData: string;
  description: string;
  appointmentDate: string;
  startMandate: string;
  predictedEnd?: string;
  endMandate?: string;
  applicantId: number;
  positionTypeName: string;
  appointmentValid: boolean;
  appointmentId: number;
  appointment?: IApplicantsAppointment;
  readOnly: boolean;
  institutionName?: string;
  mandateEndReason?: string;
}

const ApplicantsAppointmentPresentationModel = (
  data: IApplicantsAppointment
): TApplicantsAppointmentPresentationModel => {
  const appointmentDate = DateService().formatDate(data.appointmentDate);
  const startMandate = DateService().formatDate(data.startMandate);
  const predictedEnd = data.predictedEnd
    ? DateService().formatDate(data.predictedEnd)
    : undefined;
  const endMandate = data.endMandate
    ? DateService().formatDate(data.endMandate)
    : undefined;
  return {
    id: data.id,
    positionTypeId: data.positionTypeId,
    sourceData: data.sourceData,
    description: data.description || "",
    appointmentDate,
    startMandate,
    predictedEnd,
    endMandate,
    applicantId: data.applicantId,
    positionTypeName: data.positionTypeName,
    appointmentValid: data.appointmentValid,
    appointmentId: data.appointmentId,
    appointment: data,
    readOnly: data.sourceData !== SourceDataConstants.OPERATOR,
    institutionName: data.institutionName,
    mandateEndReason: data.mandateEndReason
  };
};

export default ApplicantsAppointmentPresentationModel;
